export default { PACKAGE_VERSION: "1.6.1" };
